import { FC } from "react";
import { PaginationProps } from "./pagination.types";
import { Pagination1 } from "./skins/pagination-1";

const Pagination: FC<PaginationProps> = (props) => {
  return <Pagination1 {...props} />;
};

export default Pagination;
